import { Sites } from '@ps/platform-message-framework/common/Sites';
import { FeatureFlag } from '@ps/web-core-enums';
import { Password as PasswordInput, Validation } from '@ps/web-shared-components';
import {
  checkUserPassword,
  composeValidatorsWithThreshold,
  minLength as minLengthFactory,
  mustContainLowerCaseLetter,
  mustContainNumber,
  mustContainSymbol,
  mustContainUpperCaseLetter,
  mustNotIncludeFieldValue,
  mustStartWithLetter
} from '@ps/web-shared-validators';
import React from 'react';
import { useSelector } from 'react-redux';

import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';

// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import { label, root } from '../TextInput/TextInput.scss';

import {
  TXTCLI_Password,
  TXTWCL_At_least_one_capital_letter_XA_ELL,
  TXTWCL_At_least_one_symbol_XeXgX_XX,
  TXTWCL_Have_at_least_1_number,
  TXTWCL_Must_contain_at_least_3_of_the_ELL,
  TXTWCL_Must_contain_at_least_one_digi_ELL,
  TXTWCL_N0_characters_or_more,
  TXTWCL_Start_with_a_letter
} from './Password.messages.json';

const maxLength = 20;
const minLength = 8;

const siteSpecificValidators = {
  [Sites.SPA]: [
    mustContainSymbol(TXTWCL_At_least_one_symbol_XeXgX_XX),
    mustContainUpperCaseLetter(TXTWCL_At_least_one_capital_letter_XA_ELL)
  ],
  [Sites.DE]: [
    composeValidatorsWithThreshold(
      [
        mustContainLowerCaseLetter(),
        mustContainUpperCaseLetter(),
        mustContainNumber(TXTWCL_Must_contain_at_least_one_digi_ELL),
        mustContainSymbol()
      ],
      TXTWCL_Must_contain_at_least_3_of_the_ELL,
      3
    )
  ]
};

const Password = () => {
  const site = useSelector(select.cms.getSiteId);
  const isAutofocusEnabled = useFeature(FeatureFlag.SwcSignupRmfAutofocus);
  const isSignupOneEnabled = useFeature(FeatureFlag.SwcSignupOnePage);

  return (
    <PasswordInput
      id="password"
      className={root}
      maxLength={maxLength}
      autoComplete="off"
      labelClassName={label}
      validationVariant={Validation.ImmediateList}
      label={TXTCLI_Password}
      validators={[
        minLengthFactory(minLength, { ...TXTWCL_N0_characters_or_more, values: { 0: minLength } }),
        mustStartWithLetter(TXTWCL_Start_with_a_letter),
        mustContainNumber(TXTWCL_Have_at_least_1_number),
        ...(siteSpecificValidators[site] ?? []),
        mustNotIncludeFieldValue('userId'),
        checkUserPassword
      ]}
      autoFocus={isAutofocusEnabled && !isSignupOneEnabled}
    />
  );
};

export default Password;
